export const parseIntWithCurrentValue =
    (value: string) =>
    (valueCurrent: number): number =>
        Math.round(Number.parseFloat(value)) + valueCurrent;
